export default "__VITE_ASSET__YU3mdZ_p__"